

// REPO PATH:  src/front-end/code/app/Modal/index.js
//
// REVERT-NOTE(unified-notify): NEW FILE — part of the notification
// unification branch. Delete app/Modal and restore the commented-out
// originals at each "REVERT-NOTE(unified-notify)" marker if reverting.
//
// The ONE modal shell. Previously the app had two hand-rolled copies of the
// same overlay/panel/close markup (the OTA "Verify download" popup and
// Settings' PolicyModal); both now render through this. Escape and
// click-outside both call onClose.
//
//   <Modal open={x} title="…" onClose={fn} footer={<buttons/>}>body</Modal>

import React, { useEffect } from 'react';
import styles from './modal.module.css';

const Modal = ({ open, title, onClose, footer, children }) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className={styles.overlay}
            role="dialog"
            aria-modal="true"
            aria-label={typeof title === 'string' ? title : undefined}
            onClick={onClose}
        >
            <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <span className={styles.title}>{title}</span>
                    <button
                        type="button"
                        className={styles.close}
                        aria-label="Close"
                        onClick={onClose}
                    >
                        &times;
                    </button>
                </div>
                <div className={styles.body}>{children}</div>
                {footer && <div className={styles.footer}>{footer}</div>}
            </div>
        </div>
    );
};

export default Modal;